import React, { useMemo } from "react";
import { Calendar, dateFnsLocalizer } from "react-big-calendar";
import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
import { format, getDay, parse, startOfWeek } from "date-fns";
import { fr } from "date-fns/locale";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/addons/dragAndDrop/styles.css";
import { fromLocal } from "../../lib/planning";

const localizer = dateFnsLocalizer({ format, parse, startOfWeek: (d) => startOfWeek(d, { weekStartsOn: 1 }), getDay, locales: { fr } });
const DnD = withDragAndDrop(Calendar);
const MESSAGES = { today: "Aujourd'hui", previous: "‹", next: "›", month: "Mois", week: "Semaine", day: "Jour", agenda: "Liste", date: "Date", time: "Heure",
  event: "Rendez-vous", noEventsInRange: "Aucun rendez-vous sur cette période.", showMore: (n) => `+ ${n} autres`, allDay: "Journée" };

function EventBox({ event }) {
  const r = event.resource;
  return (
    <div className="leading-tight text-[11px]" data-testid={`cal-event-${r.id}`}>
      <b>{r.type_label}</b> · {r.dossier?.label}{r.techniciens?.length ? ` — ${r.techniciens.map((t) => t.nom).join(", ")}` : ""}
    </div>
  );
}

export default function PlanningCalendar({ items, view, date, onView, onNavigate, onRange, onSelect, onSlot, onMove }) {
  const events = useMemo(() => items.map((r) => ({ id: r.id, title: `${r.type_label} · ${r.dossier?.label || ""}`, start: fromLocal(r.start), end: fromLocal(r.end), resource: r })), [items]);
  const style = (e) => {
    const r = e.resource;
    return { style: { background: r.couleur, borderColor: r.couleur, opacity: r.status === "annule" ? 0.45 : 1, textDecoration: r.status === "annule" ? "line-through" : "none",
      borderLeft: r.status === "termine" ? "4px solid #111827" : undefined } };
  };
  return (
    <div className="card-flat p-3 h-[calc(100vh-260px)] min-h-[560px] planning-cal" data-testid="planning-calendar">
      <DnD localizer={localizer} culture="fr" messages={MESSAGES} events={events} view={view} date={date} onView={onView} onNavigate={onNavigate}
        views={["month", "week", "day", "agenda"]} onRangeChange={onRange} onSelectEvent={(e) => onSelect(e.resource)} selectable onSelectSlot={onSlot}
        onEventDrop={onMove} onEventResize={onMove} resizableAccessor={() => true} eventPropGetter={style} components={{ event: EventBox }}
        min={new Date(1970, 0, 1, 7)} max={new Date(1970, 0, 1, 20)} step={30} timeslots={2} popup
        formats={{ timeGutterFormat: "HH:mm", eventTimeRangeFormat: ({ start, end }) => `${format(start, "HH:mm")}–${format(end, "HH:mm")}` }} />
    </div>
  );
}
